import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrDocumentGeneratedDateYearPercent = createSelector(
  [selectQbrState],
  (state) => state.selectedDocument?.DocumentGeneratedDateYearPercent
)
